/** @jsxImportSource @emotion/react */
import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import { jsx, css, keyframes } from "@emotion/react";
import pr from "../lib/pr";
import {
  Grid,
  Box,
  TextField,
  Badge,
  Typography,
  Dialog,
  Button,
  Paper,
  Divider,
  SwipeableDrawer,
} from "@mui/material";
import styled from "@emotion/styled";
import add_comma from "../lib/add_comma";
import queryString from "query-string";
import get_token from "../lib/get_token";
import { loginState, configState } from "../lib/State";
import axios from "axios";
import Swal from "sweetalert2";
import get_cid from "../lib/get_cid";

const HomeCash = forwardRef((props, ref) => {
  const { login } = props;
  let { flag } = queryString.parse(window.location.search);
  flag = flag !== undefined ? true : false;
  const [open, setOpen] = useState(flag);
  const [loaded, setLoaded] = useState(false);
  const [cid, setCid] = useState(get_cid());
  const [openUse, setOpenUse] = useState(false);

  // 부모창에서 자식함수 호출할때 (자식창에있는 대화상자 오픈)
  useImperativeHandle(ref, () => ({
    open() {
      setOpen(true);
      load_data();
      count_data();
    },
  }));

  const [clicked, setClicked] = useState(false);
  const [rows, setRows] = useState([]);
  const token = get_token();
  let result;

  const [count, setCount] = useState("-");

  const closeClick = () => {
    setOpen(false);
    load_data();
  };

  const load_data = async () => {
    let result;
    const postData = {
      token: token,
      cid: cid,
      mcd: login.mcd,
      level: login.level,
    };
    result = await axios.post(
      configState.api + "/gympass/home_list_cash",
      postData
    );
    if (result.data.success === 1) {
      setRows(result.data.rows);
    }
    setLoaded(true);
  };

  const count_data = async () => {
    let postData = {
      token: get_token(),
      mcd: login.mcd,
      level: login.level,
      cid: cid,
    };
    let result = await axios.post(
      configState.api + "/gympass/home_count_cash",
      postData
    );
    setCount(result.data.count);
  };

  const [currentDate, setCurrentDate] = useState(
    new Date().toISOString().slice(0, 7)
  );
  const [date, setDate] = useState(new Date().toISOString().slice(0, 7));
  const chageDate = (e) => {
    const direction = e.currentTarget.attributes.direction.value;
    let mounth = +date.slice(5, 7);
    let year = +date.slice(0, 4);
    if (direction === "prev") {
      mounth--;
      if (mounth <= 0) {
        mounth = 12;
        year -= 1;
      }
    } else {
      mounth++;
      if (mounth > 12) {
        mounth = 1;
        year += 1;
      }
    }
    mounth = ("0" + mounth).slice(-2);
    setDate(year + "-" + mounth);
  };

  return (
    <>
      <Dialog fullScreen open={openUse} onClose={() => setOpenUse(false)}>
        <Box>
          <Box
            sx={{
              width: "90%",
              textAlign: "left",
              padding: "30px 0 10px 10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <img
              src="/img/back_button_black.png"
              onClick={() => setOpenUse(false)}
            />
            <Box
              sx={{
                width: "100%",
                margin: "25px 0 0 10px",
                fontSize: "22px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
              }}
            >
              <Box>캐시 이용안내</Box>
            </Box>
          </Box>
          <Divider />
          <Box
            sx={{
              margin: "20px",
              padding: "20px",
            }}
          >
            <Box
              sx={{
                marginBottom: "20px",
              }}
            >
              <Box
                sx={{
                  fontWeight: "bold",
                }}
              >
                캐시 획득 방법
              </Box>
              <Box
                sx={{
                  fontSize: "14px",
                  marginTop: "8px",
                }}
              >
                캐시는 두 가지 방법으로 획득 가능합니다.
                <br />- 목표 심박포인트 달성 시 100캐시를 얻을 수 있습니다(매일
                최대 100캐시). 심박 포인트 화면에서 불이 들어온 이미지를
                클릭하면 캐시를 수령할 수 있습니다.
                <br></br>- 신규 회원이 추천인을 등록했을 때, 추천 받은 사람은
                5000캐시를 획득할 수 있습니다.
                <Box
                  sx={{
                    marginTop: "8px",
                  }}
                >
                  자신이 보유한 총캐시는 홈화면의 캐시 클릭 및 결제 페이지에서
                  확인가능합니다.
                </Box>
              </Box>
            </Box>
            <Box>
              <Box
                sx={{
                  fontWeight: "bold",
                }}
              >
                캐시 사용 방법
              </Box>
              <Box
                sx={{
                  fontSize: "14px",
                  marginTop: "8px",
                }}
              >
                캐시는 쿠폰을 구매할 때 사용가능합니다.
                <br></br>
                결제 페이지의 '캐시사용'란에서 본인이 보유하고 있는 캐시를
                확인할 수 있습니다.
                <Box
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  캐시사용은 전액사용만 가능합니다(일부 사용 불가능).
                </Box>
                캐시사용란의 전액사용을 클릭하면 캐시사용이 활성화되며, 총
                결제금액이 캐시금액만큼 할인됩니다.
              </Box>
            </Box>
          </Box>
        </Box>
      </Dialog>
      <Dialog fullScreen open={open} onClose={closeClick}>
        <Box>
          {/* 상단 */}
          <Box
            sx={{
              width: "90%",
              textAlign: "left",
              padding: "30px 0 10px 10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <img src="/img/back_button_black.png" onClick={closeClick} />
            <Box
              sx={{
                width: "100%",
                margin: "25px 0 0 10px",
                fontSize: "22px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
              }}
            >
              <Box>캐시내역</Box>
              <Button variant="outlined" onClick={() => setOpenUse(true)}>
                이용안내
              </Button>
            </Box>
          </Box>
          <Divider />
          <Box sx={{ pt: 3 }}></Box>

          <div className="flex w-full justify-between mt-3 mb-10 px-10">
            <div direction="prev" onClick={chageDate}>
              <img
                src="/img/next.svg"
                className="w-7 rotate-180 opacity-50"
                alt=""
              />
            </div>
            <p className="text-2xl font-bold opacity-80">{date}</p>
            {currentDate !== date ? (
              <div direction="next" onClick={chageDate}>
                <img src="/img/next.svg" className="w-7 opacity-50" alt="" />
              </div>
            ) : (
              <div className="w-7" />
            )}
          </div>

          {/* 하단 */}
          <Box>
            <Box fontSize="16px" textAlign="right" width="90%">
              보유캐시: {add_comma(count)}
            </Box>
            {loaded &&
              rows.filter((x) => x.pdate.slice(0, 7) === date).length === 0 && (
                <Box
                  sx={{
                    height: cid === "XXXXX" /*줌*/ ? "28rem" : "80vw",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                  }}
                >
                  캐시내역이 없습니다.
                </Box>
              )}
            {rows.map(
              (item, index) =>
                item.pdate.slice(0, 7) === date && (
                  <Box
                    key={index}
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      mt: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: "90%",
                        display: "flex",
                        justifyContent: "flex-start",
                        padding: "0 0 5px 2.5%",
                        fontSize: "13px",
                        color: "#979797",
                        fontWeight: "bold",
                      }}
                    >
                      <Box>{item.pdate}</Box>
                    </Box>
                    <Box
                      sx={{
                        width: "84%",
                        border: "1px solid #dcdddd",
                        padding: "10px",
                        // marginBottom: '15px',
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          aligntItems: "center",
                          marginLeft: "10px",
                        }}
                      >
                        <img
                          src="/img/dollar-coin.png"
                          style={{
                            width:
                              cid === "XXXXX" /*줌*/ ? "4rem" : "15vw",
                          }}
                        />
                      </Box>
                      <Box
                        sx={{
                          marginLeft: "10px",
                        }}
                      >
                        {item.amount > 0 ? (
                          <Box
                            sx={{
                              fontSize: "15px",
                              color: "#999999",
                              fontWeight: "500",
                            }}
                          >
                            +{add_comma(item.amount)}캐시
                            {item.rname !== ""
                              ? " (추천:" + item.rname + ")"
                              : null}
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              fontSize: "15px",
                              color: "#999999",
                              fontWeight: "500",
                            }}
                          >
                            {add_comma(item.amount)}캐시
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                )
            )}
          </Box>
          <Box sx={{ pt: 6 }}></Box>
        </Box>
      </Dialog>
    </>
  );
});

export default HomeCash;
